import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { chatroomReducers } from 'nm-react-chat';
import { quizzReducers } from 'nm-react-quiz';

import * as authReducers from './../components/Auth/authReducers';
import * as userReducers from './../components/user/userReducers';
import * as historyReducers from './../components/History/historyReducers';
import * as pointsReducers from './../components/Points/pointsReducers';
import * as thematicsReducers from './../components/Thematics/thematicsReducers';
import * as editionsReducers from './../components/Editions/editionsReducers';
import * as articleReducers from './../components/Article/articleReducers';
import * as setupReducers from './../components/SetupLoader/setupLoaderReducers';
import * as resetPasswordReducers from './../components/ResetPassword/resetPasswordReducers';
import * as updateSystemReducers from './../components/UpdateSystem/updateSystemReducers';
import datasStore from './../components/StorePage/StoreReducers';

export default combineReducers({
    auth: authReducers.auth,
    user: userReducers.user,
    article: articleReducers.article,
    editions: editionsReducers.editions,
    thematics: thematicsReducers.thematics,
    setup: setupReducers.setup,
    history: historyReducers.history,
    points: pointsReducers.points,
    resetPassword: resetPasswordReducers.resetPassword,
    chatroom: chatroomReducers,
    quizz: quizzReducers,
    router: routerReducer,
    updateSystem: updateSystemReducers.updateSystem,
    datasStore
});


// WEBPACK FOOTER //
// ./src/app/reducers.js